import React from 'react';
import { Offcanvas, OffcanvasHeader, OffcanvasBody, Button } from 'reactstrap';
import { Link } from 'react-router-dom';

import { TASK_PRIORITY } from '../../../../constants/tasks';
import MarkdownViewer from '../../../../components/Common/MarkdownViewer';

const formatWhatsAppNumber = (phone) => {
    if (!phone) return null;
    return phone.replace(/\D/g, '');
};

const OperationalItemSidebar = ({ isOpen, toggle, item }) => {
    if (!item) return null;

    return (
        <Offcanvas isOpen={isOpen} toggle={toggle} direction="end" style={{ width: "450px" }}>
            <OffcanvasHeader toggle={toggle} className="border-bottom pb-3 bg-light-subtle">
                <div className="d-flex align-items-center gap-2">
                    <span className={`badge rounded-pill bg-${item.badgeInfo?.color || 'primary'} bg-opacity-10 text-${item.badgeInfo?.color || 'primary'} border border-${item.badgeInfo?.color || 'primary'}-subtle font-size-12 px-2 shadow-sm`}>
                        {item.badgeInfo?.text}
                    </span>
                    {item.priority === TASK_PRIORITY.HIGH && (
                        <span className="badge rounded-pill bg-danger bg-opacity-10 text-danger border border-danger-subtle font-size-12 px-2 shadow-sm ms-1">
                            Alta Prioridade
                        </span>
                    )}
                    {item.priority === TASK_PRIORITY.LOW && (
                        <span className="badge rounded-pill bg-success bg-opacity-10 text-success border border-success-subtle font-size-12 px-2 shadow-sm ms-1">
                            Baixa Prioridade
                        </span>
                    )}
                    <span className="text-muted small ms-2 fw-medium">
                        <i className="mdi mdi-clock-outline me-1"></i>
                        {item.date}
                    </span>
                </div>
            </OffcanvasHeader>
            <OffcanvasBody className="p-4 bg-white d-flex flex-column h-100">
                <h4 className="fw-bold text-dark mb-3" style={{ letterSpacing: '-0.3px' }}>{item.title}</h4>
                {item.description && (
                    <div className="bg-light bg-opacity-50 border rounded-3 p-3 mb-4 mt-2">
                        <MarkdownViewer text={item.description} className="text-muted font-size-13" />
                    </div>
                )}

                {item.memberNumber && (
                    <div className="mb-4">
                        <h6 className="fw-bold mb-3 font-size-12 text-uppercase text-muted">Cliente Vinculado</h6>
                        <div className="d-flex align-items-center">
                            <div className="avatar-sm me-3 flex-shrink-0">
                                {item.memberPhotoUrl ? (
                                    <img src={item.memberPhotoUrl} alt="Cliente" className="img-thumbnail rounded-circle h-100 w-100 object-fit-cover p-0 border" />
                                ) : (
                                    <span className="avatar-title bg-primary bg-opacity-10 text-primary rounded-circle fw-bold border border-primary-subtle">
                                        {(item.memberName?.charAt(0) || 'C').toUpperCase()}
                                    </span>
                                )}
                            </div>
                            <div className="flex-grow-1 overflow-hidden">
                                <h6 className="font-size-14 mb-1 text-truncate fw-semibold text-dark">{item.memberName || 'Cliente'}</h6>
                                {item.memberPhone && <p className="text-muted font-size-13 mb-0 text-truncate">{item.memberPhone}</p>}
                                {item.memberEmail && <p className="text-muted font-size-13 mb-0 text-truncate">{item.memberEmail}</p>}
                            </div>
                            <div className="d-flex gap-2 flex-shrink-0 ms-2">
                                <Link
                                    to={`/members/${item.id}`}
                                    title="Acessar Ficha do Cliente"
                                    onClick={toggle}
                                    className="btn btn-primary rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                                    style={{ width: '36px', height: '36px', padding: 0 }}
                                >
                                    <i className="mdi mdi-eye-outline font-size-18 text-white m-0 p-0"></i>
                                </Link>

                                {item.memberPhone && (
                                    <a
                                        href={`https://wa.me/55${formatWhatsAppNumber(item.memberPhone)}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        title="Enviar Mensagem no WhatsApp"
                                        className="btn btn-success rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                                        style={{ width: '36px', height: '36px', padding: 0 }}
                                    >
                                        <i className="mdi mdi-whatsapp font-size-18 text-white m-0 p-0"></i>
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {item.assignedEmployees && item.assignedEmployees.length > 0 && (
                    <div className="mb-4">
                        <h6 className="fw-bold mb-3 font-size-12 text-uppercase text-muted">Colaboradores Responsáveis</h6>
                        <div className="d-flex flex-wrap gap-2">
                            {item.assignedEmployees.map((emp, idx) => (
                                <div key={emp.id || idx} className="badge bg-light text-dark border py-2 px-3 d-flex align-items-center gap-2 rounded-3 shadow-sm">
                                    <div className="avatar-xs flex-shrink-0">
                                        {emp.photoUrl ? (
                                            <img src={emp.photoUrl} alt="Colaborador" className="img-thumbnail rounded-circle h-100 w-100 object-fit-cover p-0" />
                                        ) : (
                                            <span className="avatar-title bg-secondary bg-opacity-10 text-secondary rounded-circle fw-bold font-size-10">
                                                {(emp.name?.charAt(0) || 'C').toUpperCase()}
                                            </span>
                                        )}
                                    </div>
                                    <span className="fw-medium font-size-13 text-truncate">
                                        {emp.name || 'Colaborador'}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                <div className="mt-auto border-top pt-4 pb-2">
                    <Button color="light" onClick={toggle} className="w-100 py-2 fw-semibold rounded-3 font-size-14 text-muted border shadow-sm transition-all hover-scale">
                        Fechar
                    </Button>
                </div>
            </OffcanvasBody>
        </Offcanvas>
    );
};

export default OperationalItemSidebar;
